import React from 'react';
import { useRouteError } from 'react-router-dom';
import styles from './index.module.less';

type CommonError = {
  message?: string;
  stack?: string;
  status?: number;
};

const ErrorBoundary = () => {
  const error = useRouteError() as CommonError;
  console.dir(error);

  return (
    <div className={styles.container}>
      <div className={styles.title}>Ops! 程序出错了</div>
      {
        error?.status === 404 ? (
          <div className={styles.content}>
            404:
            <span className={styles.message}>页面未找到</span>
          </div>
        ) : (
          <div className={styles.content}>
            错误信息:
            <span className={styles.message}>{error?.message}</span>
          </div>
        )
      }
    </div>
  );
};

export default ErrorBoundary;
